import React, { useState, useEffect } from "react"
import SignupLayout from ".";
import { PeopleIcon } from "../../components/Icons/iconImages";
import InputField from "../../components/InputField";
import { Button } from "antd";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import { useRegisterUserWithReferralCodeMutation } from "../../services/authSlice";
import { toast } from "../../components/Toast/toast";


const EnterReferralCode = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Read referral code from sessionStorage BEFORE initializing form
    const storedReferralCode = sessionStorage.getItem('referral_code') || '';

    const defaultValues = {
        referralCode: storedReferralCode,
    };
    const {
        getValues,
        handleSubmit,
        control,
        formState: { errors },
        setValue,
    } = useForm({
        defaultValues,
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [registerWithReferralCode] = useRegisterUserWithReferralCodeMutation();

    const handleContinue = async () => {
        const referralCode = getValues('referralCode').trim();

        // If no referral code entered, skip to next step
        if (!referralCode) {
            sessionStorage.removeItem('referral_code');
            navigate('/about-your-company', {
                state: location?.state
            });
            return;
        }

        // If referral code is entered, register it
        setLoading(true);
        try {
            await registerWithReferralCode({
                fullname: location?.state?.fullname,
                email: location?.state?.email,
                referral_code: referralCode
            }).unwrap();

            toast.success('Referral code applied successfully!');
            sessionStorage.removeItem('referral_code');
            setLoading(false);
            navigate('/about-your-company', {
                state: location?.state
            });
        } catch (err: any) {
            setLoading(false);
            setError(err?.data?.message || 'Invalid referral code');
        }
    };

    const handleSkip = () => {
        sessionStorage.removeItem('referral_code');
        navigate('/about-your-company', {
            state: location?.state
        });
    };

    const handleSubmitError = (data: any) => {
        // Handle form errors if needed
    };

    return (
        <SignupLayout
            title={<p className="text-[#FFFFFF] font-bold text-6xl 2xl:text-7xl mt-3">Join the <br />Community</p>}
            description={<p className="text-[#FFFFFF] text-xl mt-3">
                Got a referral code from a friend? {' '}
                <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
                    <span className="absolute h-[5px] w-[5px] top-[-3px]  left-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] top-[-3px]  right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    Get 1 month free
                </span>{' '}
                on us! Enjoy premium features while you grow your business together.
            </p>}
            icon={<PeopleIcon className="h-[80px] w-[80px] text-white" />}
            percent={20}
            currentStep={2}
        >
            <div className="mx-auto h-[calc(97vh-18.9rem)]">
                <div className="text-center mt-8">
                    <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
                        <PeopleIcon className="text-[#181D27]" />
                    </div>
                    <p className="text-[#181D27] font-semibold text-3xl mt-4">Have a referral code?</p>
                    <p className="text-[#535862] text-md mt-2">Enter your referral code to get 1 month free. You can skip this step if you don't have one.</p>
                </div>
                <form onSubmit={handleSubmit(handleContinue, handleSubmitError)} className="flex flex-col items-center justify-between mt-6 h-full gap-6">
                    <div className="w-full max-w-[416px] p-4 rounded-2xl flex flex-col space-y-5 md:space-y-5 h-full">
                        <InputField
                            control={control}
                            label={'Referral Code (Optional)'}
                            placeholder={'Enter referral code'}
                            name="referralCode"
                            rules={{
                                required: false,
                            }}
                            error={errors.referralCode}
                        />
                        {storedReferralCode && (
                            <div className="flex items-start gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
                                <Icons icon={"heroicons-outline:check-circle"} className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                                <p className="text-sm text-green-700">
                                    <span className="font-semibold">Referral code found!</span> We've automatically applied your referral code. You'll get 1 month free when you confirm.
                                </p>
                            </div>
                        )}
                        {error && (
                            <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                                <p className='text-red-500 text-sm'>{error}</p>
                                <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" onClick={() => setError('')} />
                            </div>
                        )}
                    </div>
                    <div className="flex items-center max-w-[416px] gap-3 w-full">
                        <Button
                            type='primary'
                            className="w-full"
                            disabled={loading}
                            loading={loading}
                            htmlType="submit"
                        >
                            Continue
                        </Button>
                    </div>
                </form>
            </div>
        </SignupLayout>
    )
};

export default EnterReferralCode;
